/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

/**
 * 紐づけるアンケートテンプレ（1動画=1テンプレ・共有可・ADR-0015）
 * @nullable
 */
export type ScenarioVideoSurveyId = Cuid | null
